import request from '@/utils/request'

let EquityApi = {
    getSetting(data, errorback) {
        return request._get('/shop/user.Equity/getSetting', data, errorback);
    },
    saveSetting(data, errorback) {
        return request._post('/shop/user.Equity/getSetting', data, errorback);
    },
}

export default EquityApi;



// WEBPACK FOOTER //
// ./src/api/equity.js